import { DS_BASE_URL, getStatBaseData, } from './utils/sendBiEvent';
import withTimeout from './withTimeout';

export default function fireBiRequest() {
  if (window.location.hostname === 'localhost') return;
  getStatBaseData().then(stat => {
    try {
      withTimeout(
        window.fetch(`${DS_BASE_URL}/request`, {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(stat),
          cache: 'no-cache',
          credentials: 'include',
        })
      );
    }
    catch (err) {
      // eslint-disable-next-line no-console
      console.error(err.stack);
    }
  });
}
